import { IClassname } from '@/lib/shared/model/classname';

export const Technician = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.02515 30.3331V21.6982"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.9722 30.3328V21.6953"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3928 19.3753V24.7771C21.3918 25.2967 21.1846 25.7945 20.8168 26.1617C20.4492 26.5287 19.9508 26.7348 19.4312 26.7348H12.5688C12.0492 26.7348 11.5508 26.5287 11.1831 26.1617C10.8153 25.7945 10.6082 25.2967 10.6072 24.7771V19.374"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.54028 30.3331C3.54193 28.0098 4.19243 25.7332 5.41845 23.7598C6.64447 21.7865 8.3973 20.1947 10.4794 19.1641C11.0398 20.132 11.8449 20.9354 12.8138 21.4941C13.7828 22.0527 14.8815 22.3467 16 22.3467C17.1184 22.3467 18.2172 22.0527 19.1861 21.4941C20.1551 20.9354 20.9601 20.132 21.5206 19.1641C23.6027 20.1947 25.3555 21.7865 26.5815 23.7598C27.8075 25.7332 28.458 28.0098 28.4597 30.3331"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1956 16V14.722C12.1969 13.9162 12.5171 13.1435 13.0863 12.5729C13.6554 12.0023 14.4273 11.6801 15.2332 11.6768H16.7539C17.5615 11.6774 18.3361 11.9984 18.9074 12.5693C19.4788 13.1402 19.8003 13.9144 19.8017 14.722V16"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3342 14.1309H16.6633"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4442 9.15165C13.2678 9.15165 13.1248 9.00862 13.1248 8.83217C13.1248 8.65573 13.2678 8.5127 13.4442 8.5127"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M13.4441 9.15165C13.6206 9.15165 13.7636 9.00862 13.7636 8.83217C13.7636 8.65573 13.6206 8.5127 13.4441 8.5127"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M18.5558 9.15165C18.3793 9.15165 18.2363 9.00862 18.2363 8.83217C18.2363 8.65573 18.3793 8.5127 18.5558 8.5127"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M18.5559 9.15165C18.7324 9.15165 18.8754 9.00862 18.8754 8.83217C18.8754 8.65573 18.7324 8.5127 18.5559 8.5127"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M22.7091 8.37606C22.7091 6.5967 22.0023 4.89022 20.7441 3.63204C19.4859 2.37384 17.7794 1.66699 16.0001 1.66699C14.2207 1.66699 12.5143 2.37384 11.2561 3.63204C9.99786 4.89022 9.29102 6.5967 9.29102 8.37606V10.6124C9.29102 12.3918 9.99786 14.0982 11.2561 15.3564C12.5143 16.6147 14.2207 17.3215 16.0001 17.3215C17.7794 17.3215 19.4859 16.6147 20.7441 15.3564C22.0023 14.0982 22.7091 12.3918 22.7091 10.6124V8.37606Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
